import { H1, Link, Typography } from '@vp/swan';
import { useTrackNavigationClicked } from '../../utils/analytics';
import LogomakerAnywhere from '../LogomakerAnywhere/LogomakerAnywhere';
import DomainNames from './DomainNames';
import type { BusinessName } from '../../pages/BusinessNameGeneratorPage/components/BusinessNameResults/BusinessNameResults';

type BusinessNameDetailProps = {
    businessName: BusinessName;
    trackingEventDetails: {
        category: string;
    };
    keyword?: string;
    industryKeywords?: string[];
};

const BusinessNameDetail = ({
    businessName,
    trackingEventDetails,
    keyword,
    industryKeywords,
}: BusinessNameDetailProps) => {
    const processedKeyword = keyword || industryKeywords?.[0] || '';
    const processedIndustryKeywords =
        keyword || !industryKeywords ? industryKeywords : industryKeywords?.slice(1);

    const title = 'Get a logo, like, now!';
    const logoIdeasRef = useTrackNavigationClicked(
        'LogomakerAnywhere',
        'LogomakerAnywhere',
        '/logomaker/ideas',
        'logoIdeas',
    );

    const description = (
        <>
            Try our free Logomaker and see your business name come to life in seconds. Don't know
            where to start? Get inspired with our range of{' '}
            <Link href="/logomaker/ideas" target="_blank" ref={logoIdeasRef}>
                logo ideas
            </Link>
            .
        </>
    );

    return (
        <>
            <H1 fontSkin="title-section">{businessName.name}</H1>
            <Typography>{businessName.description}</Typography>
            <DomainNames businessName={businessName} trackingEventDetails={trackingEventDetails} />
            {businessName.name && (
                <LogomakerAnywhere
                    title={title}
                    description={description}
                    initialBusinessName={businessName.name}
                    keyword={processedKeyword}
                    industryKeywords={processedIndustryKeywords}
                    showBusinessNameInput={false}
                    isModalLayout
                />
            )}
        </>
    );
};

export default BusinessNameDetail;
